<template>
    <div class="company">
      <companyIntro></companyIntro>
    </div>
</template>


<script>
  import companyIntro from "../../components/companyIntro/companyIntro";
    export default {
        name: "company",
        components:{
            companyIntro
        },

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/company/company.vue